// Copyright (c) 2017 Deere & Company

import KeyValuePairCollection, {getDefaultState as getKeyValuePairCollectionDefaultState} from '@deere/cps-it.warranty-model-factory/lib/key-value-pair-collection';
import ProductHierarchy, {getDefaultState as getProductHierarchyDefaultState} from '@deere/cps-it.warranty-model-factory/lib/product-hierarchy';
import Range, {getDefaultState as getRangeDefaultState} from '@deere/cps-it.warranty-model-factory/lib/range';
import DateRange from '@deere/cps-it.warranty-model-factory/lib/date-range';
import moment from 'moment';
import t from 'tcomb';

const Facets = t.struct({
    allowedClaimTypes: KeyValuePairCollection,
    allowedProductHierarchy: ProductHierarchy,
    dateIssued: DateRange,
    reimbursedAmount: Range,
    reimbursedPercentage: Range,
    selectedClaimTypes: KeyValuePairCollection,
    selectedProductCode: t.String,
    showReimbursedAmount: t.Bool
}, {
    name: 'Facets',
    strict: true
});

export const getDefaultState = () =>
    new Facets({
        allowedClaimTypes: getKeyValuePairCollectionDefaultState(),
        allowedProductHierarchy: getProductHierarchyDefaultState(),
        dateIssued: new DateRange({
            from: moment.utc()
                .startOf('day')
                .subtract(1, 'month')
                .startOf('day')
                .valueOf(),
            to: moment.utc()
                .startOf('day')
                .endOf('day')
                .valueOf()
        }),
        reimbursedAmount: getRangeDefaultState(),
        reimbursedPercentage: getRangeDefaultState(),
        selectedClaimTypes: getKeyValuePairCollectionDefaultState(),
        selectedProductCode: '',
        showReimbursedAmount: true
    });

export default Facets;



// WEBPACK FOOTER //
// ./src/tcsm/claim-search/state/facets.js